import { getApiUrl } from "./tcApiUrl";
export function getDateRangeURL() {
  const classifyurl = `${getApiUrl("tc")}`;
  return classifyurl;
}

export const getDateRangeURLValue = () => {
  return getDateRangeURL();
};
